import { systemPath } from '@/mocks/tradingData';
import Reveal from '@/components/base/Reveal';

function ProcessPath() {
  return (
    <section
      id="process"
      className="w-full bg-background-100 border-y border-background-200 px-4 md:px-8 lg:px-12 py-16 md:py-24"
    >
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <p className="text-[11px] font-data tracking-[0.24em] text-primary-600 mb-5">
            SYSTEM PATH
          </p>
          <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[34px] leading-[1.08] sm:text-[44px] lg:text-[50px] max-w-[760px]">
            From Market Data to Execution
          </h2>
        </Reveal>

        <div className="relative mt-16 md:mt-20">
          <div className="hidden md:block absolute top-[5px] left-[9%] right-[9%] h-px bg-primary-300/60"></div>
          <div className="md:hidden absolute left-[5px] top-[8px] bottom-[8px] w-px bg-primary-300/60"></div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-12 md:gap-6">
            {systemPath.map((stage, idx) => (
              <Reveal key={stage.index} delay={idx * 150}>
                <div className="flex md:block items-start gap-4">
                  <span className="shrink-0 mt-0.5 md:mt-0 block w-[11px] h-[11px] rounded-full border border-primary-500 bg-background-50"></span>
                  <div className="md:mt-7">
                    <span className="block font-data text-[12px] tracking-[0.2em] text-primary-600">
                      {stage.index}
                    </span>
                    <h3 className="mt-2 font-heading font-bold tracking-tight text-foreground-950 text-[19px] md:text-[21px]">
                      {stage.title}
                    </h3>
                    <p className="mt-2.5 text-[13px] leading-relaxed text-foreground-500 max-w-[220px]">
                      {stage.detail}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProcessPath;